/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Specialskills1Inputs */

const de__field_specialskills1 = /** @type {(inputs: _Field_Specialskills1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besondere Fähigkeiten`)
};

/**

* @param {_Field_Specialskills1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_specialskills1 = /** @type {((inputs?: _Field_Specialskills1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Specialskills1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_specialskills1(inputs)
});
export { _field_specialskills1 as "_field_specialSkills" }